import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TooltipPortal } from './components/TooltipPortal/index';
import { Main } from './pages/Main/Main.js';
import { Playground } from './pages/Playground/Playground.js';
import Home from './pages/Home/index';
import Waitlist from './pages/Waitlist/index';
import { NotFound } from './pages/NotFound/NotFound.js';
import './styles/fonts.css';
import './styles/variables.css';
import './styles/reset.css';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/app" element={<Main singleTheme />} />
          <Route path="/r9w-c5l7r3s" element={<Main />} />
          <Route path="/r9w-c5l7r3s/playground" element={<Playground />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
      <TooltipPortal />
      <Analytics />
    </div>
  );
}

export default App;
